<template>
	<div class="base_card" :class="`base_card__${type} base_card__${size}`">
		<div class="base_card__header" :class="headerBorder ? 'border-bottom' : ''">
			<slot v-if="$slots.title" name="title"></slot>
			<span v-else>{{ title }}</span>
			<slot name="action"></slot>
		</div>
		<div class="base_card__body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaseCard',
		props: {
			headerBorder: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: '--'
			},
			type: {
				type: String,
				default: 'default'
			}
		}
	};
</script>

<style scoped lang="less">
	.base_card {
		box-sizing: border-box;
		padding: 28px;
		border-radius: 16px;
		background-color: #fff;
		&__header {
			padding-bottom: 28px;
			min-height: 50px;
			font-family: PingFangSC-Semibold;
			font-size: 36px;
			line-height: 50px;
			font-weight: 600;
			color: #1F2329;
		}
		&.base_card__primary {
			background-color: @primary;
			.card_header { color: #fff; }
		}
		&.base_card__small {
			.card_header {
				font-size: 30px;
			}
		}
	}
</style>
